// src/hooks/clientes/use-cliente-kpis.ts
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { clienteService } from "@/services/api/cliente.service";

export function useClienteKpis() {
  const queryClient = useQueryClient();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["clientes-resumo-totais"],
    queryFn: () => clienteService.getResumoTotais(),
    staleTime: 1000 * 60 * 5,
  });

  // Fallback seguro caso a API ainda não tenha retornado
  const resumo = {
    totalClientes: data?.totalClientes || 0,
    filiaisPendentes: data?.filiaisPendentes || 0,
    totalFiliais: data?.totalFiliais || 0,
  };

  const fetchTotais = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["clientes-resumo-totais"] }),
      queryClient.invalidateQueries({ queryKey: ["clientes-matriz-v1"] }),
      queryClient.invalidateQueries({ queryKey: ["filiais-pendentes"] }),
      queryClient.invalidateQueries({ queryKey: ["filiais-todas"] }),
    ]);

    await refetch();
  };

  return {
    resumo,
    isLoading,
    fetchTotais,
  };
}
